<template>
  <div
    class="flex flex-col gap-6 w-full h-fit bg-white border border-grays-400 rounded py-6 pl-4 pr-9"
  >
    <div class="flex flex-row w-full h-fit items-center">
      <h3 class="flex-1 text-xl font-medium text-primary-700 min-h-9">
        ניהול זיכויים
      </h3>
      <div class="flex flex-row items-center gap-4">
        <button-icon v-if="!editMode" @click="toggleEditMode">edit</button-icon>
      </div>
    </div>
    <div class="flex flex-row gap-9 items-end">
      <div class="xl:flex flex-row gap-20">
        <div class="md:flex flex-col gap-4">
          <p class="text-grays-900 font-medium text-lg">
            מה תרצו לעשות עם זיכויים ממתינים?
          </p>
          <div class="md:flex flex-row gap-4">
            <check-box
              :disabled="!editMode"
              :model-value="refundOption === 'account'"
              @update:model-value="onSelect('account', $event)"
            >
              להשאיר אצלכם בארנק במשנת יוסף
            </check-box>
            <check-box
              :disabled="!editMode"
              :model-value="refundOption === 'credit'"
              @update:model-value="onSelect('credit', $event)"
            >
              לקבל החזר לאמצעי התשלום ({{
                refundOption === "account" ? "מכאן ולהבא" : "ברירת מחדל"
              }})
            </check-box>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editMode" class="flex flex-col items-end">
      <button-secondary @click="handleSave">לעדכן פרטים</button-secondary>
    </div>
  </div>
</template>

<script>
import ButtonIcon from "@/components/Global/ButtonIcon.vue";
import CheckBox from "@/components/Global/CheckBox.vue";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import axiosInstance from "@/helpers/axios";

export default {
  name: "ManagingRefund",
  components: { ButtonSecondary, CheckBox, ButtonIcon },
  props: {
    profileData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editMode: false,
      refundOption: "credit", // default
    };
  },
  mounted() {
    this.initData();
  },
  watch: {
    profileData() {
      this.initData();
    },
  },
  methods: {
    initData() {
      this.refundOption =
        this.profileData.refund_to_card === 0 ? "account" : "credit";
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    onSelect(option, checked) {
      if (checked) {
        this.refundOption = option;
      }
    },
    async handleSave() {
      try {
        const refundToCard = this.refundOption === "credit" ? 1 : 0;
        await axiosInstance.post(
          `/profile/update_refund_to_Card/${refundToCard}`
        );

        this.toggleEditMode();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
</style>